(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.document) api.mountAll(root.document);
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';
  var W = 420, H = 700, FLOOR = 650, RADIUS = 18, FIXED = 1 / 120;
  function clamp(n, lo, hi) { return Math.max(lo, Math.min(hi, n)); }
  function randomSource(seed) {
    return function () { seed |= 0; seed = seed + 0x6D2B79F5 | 0; var t = Math.imul(seed ^ seed >>> 15, 1 | seed); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; };
  }
  function rectangles(o) {
    return [{ x: o.x + 5, y: -30, w: o.width - 10, h: o.gapY - o.gap / 2 + 30 },
      { x: o.x, y: o.gapY - o.gap / 2 - 22, w: o.width, h: 22 },
      { x: o.x + 5, y: o.gapY + o.gap / 2, w: o.width - 10, h: H - o.gapY - o.gap / 2 },
      { x: o.x, y: o.gapY + o.gap / 2, w: o.width, h: 22 }];
  }
  function intersects(player, rect) {
    var dx = player.x - clamp(player.x, rect.x, rect.x + rect.w), dy = player.y - clamp(player.y, rect.y, rect.y + rect.h);
    return dx * dx + dy * dy < RADIUS * RADIUS;
  }
  function createGame(options) {
    options = options || {};
    var rng = randomSource(options.seed === undefined ? Date.now() : options.seed);
    var state = { phase: 'ready', score: 0, distance: 0, time: 0, night: 0, player: { x: 104, y: 320, vy: 0 }, obstacles: [], jumpAge: 10 };
    var previousGap = 330;
    function formation(x) {
      previousGap = clamp(previousGap + (rng() - 0.5) * 140, 200, 455);
      return { x: x, width: 62 + Math.floor(rng() * 4) * 8, gapY: previousGap, gap: 232 + Math.floor(rng() * 22), passed: false, tone: Math.floor(rng() * 3), spacing: 282 + rng() * 30 };
    }
    function jump() { if (state.phase !== 'running') return; state.player.vy = -285; state.jumpAge = 0; }
    function start() {
      state.phase = 'running'; state.score = 0; state.distance = 0; state.time = 0; state.night = 0;
      state.player.y = 320; state.player.vy = 0; state.obstacles = []; previousGap = 330;
      state.obstacles.push(formation(W + 100)); jump();
    }
    function step(dt) {
      if (state.phase !== 'running') return;
      dt = Math.min(dt, FIXED);
      state.time += dt; state.jumpAge += dt;
      state.player.vy += 720 * dt; state.player.y += state.player.vy * dt;
      var movement = 123 * dt; state.distance += movement;
      state.obstacles.forEach(function (o) { o.x -= movement; });
      var last = state.obstacles[state.obstacles.length - 1];
      if (last.x < W) state.obstacles.push(formation(last.x + last.spacing));
      var collision = state.player.y - RADIUS < 0 || state.player.y + RADIUS > FLOOR;
      state.obstacles.forEach(function (o) { if (rectangles(o).some(function (r) { return intersects(state.player, r); })) collision = true; });
      if (collision) { state.phase = 'over'; return; }
      state.obstacles.forEach(function (o) { if (!o.passed && o.x + o.width < state.player.x - RADIUS) { o.passed = true; state.score++; } });
      state.obstacles = state.obstacles.filter(function (o) { return o.x + o.width > -20; });
      var interval = Math.max(1, options.dayNightInterval || 30), target = Math.floor(state.score / interval) % 2;
      state.night += (target - state.night) * Math.min(1, dt * 0.8);
    }
    return { state: state, start: start, jump: jump, step: step };
  }
  function qualifies(state, threshold) { return state.phase === 'over' && state.score >= Math.max(1, threshold || 10); }
  function rewardUrl(source, destination, persistence) {
    var url = new URL(destination, source), from = new URL(source);
    if (from.searchParams.has('preview_theme_id')) url.searchParams.set('preview_theme_id', from.searchParams.get('preview_theme_id'));
    url.searchParams.delete('unlocked');
    url.searchParams.set('persistence', persistence || 'session');
    return url.pathname + url.search;
  }
  var personalBestMemory = 0, personalBestKey = 'ns-game-personal-best-v1';
  function readPersonalBest() {
    try {
      var stored = window.localStorage.getItem(personalBestKey);
      var value = typeof stored === 'string' && /^\d+$/.test(stored) ? Number(stored) : 0;
      if (Number.isSafeInteger(value) && value >= 0) personalBestMemory = Math.max(personalBestMemory, value);
    } catch (ignore) { /* Keep the best from this page when browser storage is unavailable. */ }
    return personalBestMemory;
  }
  function savePersonalBest(score) {
    var previousBest = readPersonalBest();
    if (Number.isSafeInteger(score) && score >= 0 && score > previousBest) {
      personalBestMemory = score;
      try { window.localStorage.setItem(personalBestKey, String(score)); } catch (ignore) { /* In-memory best stays usable. */ }
    }
    return personalBestMemory;
  }
  function mountAll(doc) {
    if (doc.__northstarGameBootstrapped) return;
    doc.__northstarGameBootstrapped = true;
    function mount(el) {
      if (el.dataset.nsMounted) return;
      var canvas = el.querySelector('canvas'), ctx = canvas.getContext('2d'); if (!ctx) return;
      el.dataset.nsMounted = 'true';
      var overlay = el.querySelector('[data-game-overlay]'), title = el.querySelector('[data-game-title]'), message = el.querySelector('[data-game-message]');
      var start = el.querySelector('[data-game-start]'), hats = el.querySelector('[data-game-hats]'), score = el.querySelector('[data-game-score]');
      var rewardArt = el.querySelector('[data-game-reward-art]');
      var best = el.querySelector('[data-game-best]');
      if (best) best.textContent = String(readPersonalBest()).padStart(2, '0');
      var countdown = el.querySelector('[data-game-countdown]'), status = el.querySelector('[data-game-status]'), pauseButton = el.querySelector('[data-game-pause]');
      var readyCopy = { title: title.textContent, message: message.textContent, start: start.textContent };
      var model = createGame({ dayNightInterval: Number(el.dataset.nightInterval) || 30 }), state = model.state;
      var sprite = new Image(); sprite.src = el.dataset.starSrc;
      var fallSprite = new Image(), bumpSprite = new Image();
      if (el.dataset.starFallSrc) fallSprite.src = el.dataset.starFallSrc;
      if (el.dataset.starBumpSrc) bumpSprite.src = el.dataset.starBumpSrc;
      var accumulator = 0, previous = 0, frame = 0, redirectTimer = 0, seconds = 10, paused = false, destroyed = false, lastScore = -1;
      var abort = new AbortController(), eventOptions = { signal: abort.signal };
      var persistence = el.dataset.persistence || 'session';
      var destination = rewardUrl(location.href, el.dataset.hatsUrl, persistence);
      hats.href = destination;
      function stopRedirect() { clearInterval(redirectTimer); redirectTimer = 0; countdown.textContent = ''; }
      function begin() {
        stopRedirect(); if (rewardArt) rewardArt.hidden = true; hats.hidden = true; paused = false; pauseButton.textContent = el.dataset.pauseText; pauseButton.hidden = false;
        model.start(); accumulator = 0; previous = 0; lastScore = -1; overlay.hidden = true;
        canvas.focus({ preventScroll: true }); status.textContent = el.dataset.runningText;
      }
      function finish() {
        var personalBest = savePersonalBest(state.score);
        if (best) best.textContent = String(personalBest).padStart(2, '0');
        pauseButton.hidden = true; overlay.hidden = false; start.textContent = el.dataset.replayText;
        var unlocked = qualifies(state, Number(el.dataset.threshold));
        title.textContent = unlocked ? el.dataset.unlockedTitle : el.dataset.overTitle;
        message.textContent = unlocked ? el.dataset.congratsText : el.dataset.resultText.replace('{score}', state.score);
        status.textContent = message.textContent; hats.hidden = !unlocked;
        if (rewardArt) rewardArt.hidden = !unlocked;
        if (unlocked) {
          try {
            window[persistence === 'local' ? 'localStorage' : 'sessionStorage'].setItem('ns-game-hats-unlocked', '1');
          } catch (ignore) {
            hats.hidden = true; countdown.textContent = el.dataset.storageUnavailableText;
            status.textContent = message.textContent + ' ' + el.dataset.storageUnavailableText;
            return;
          }
          seconds = 10;
          countdown.textContent = el.dataset.countdownText.replace('{seconds}', seconds);
          redirectTimer = setInterval(function () {
            if (doc.hidden) return;
            seconds--; countdown.textContent = el.dataset.countdownText.replace('{seconds}', seconds);
            if (seconds <= 0) { stopRedirect(); location.assign(destination); }
          }, 1000);
        }
      }
      function action(event) {
        if (event) event.preventDefault();
        if (state.phase === 'ready') begin();
        else if (state.phase === 'running' && !paused) model.jump();
      }
      function pause(force) {
        if (state.phase !== 'running') return;
        paused = typeof force === 'boolean' ? force : !paused; previous = 0; accumulator = 0;
        pauseButton.textContent = paused ? el.dataset.resumeText : el.dataset.pauseText;
        status.textContent = paused ? el.dataset.pausedText : el.dataset.runningText;
      }
      canvas.addEventListener('pointerdown', action, eventOptions);
      start.addEventListener('click', begin, eventOptions);
      pauseButton.addEventListener('click', function () { pause(); canvas.focus({ preventScroll: true }); }, eventOptions);
      el.addEventListener('keydown', function (event) {
        if (event.target.closest('a,button,input,select,textarea')) return;
        if (event.code === 'Space' || event.code === 'ArrowUp') { if (!event.repeat) action(event); else event.preventDefault(); }
        else if (event.code === 'Escape' || event.code === 'KeyP') { event.preventDefault(); pause(); }
      }, eventOptions);
      doc.addEventListener('visibilitychange', function () { if (doc.hidden) pause(true); }, eventOptions);
      hats.addEventListener('click', stopRedirect, eventOptions);
      function brick(rect, tone) {
        var palette = [['#b2694c','#d99c6c','#663f40'], ['#ae8057','#e1b47a','#654d44'], ['#897380','#bc9b99','#514450']][tone];
        ctx.save(); ctx.beginPath(); ctx.rect(rect.x, rect.y, rect.w, rect.h); ctx.clip();
        ctx.fillStyle = palette[0]; ctx.fillRect(rect.x, rect.y, rect.w, rect.h);
        var row = 0;
        for (var y = Math.floor(rect.y / 22) * 22; y < rect.y + rect.h; y += 22) {
          ctx.fillStyle = palette[2]; ctx.fillRect(rect.x, y, rect.w, 3);
          ctx.fillStyle = palette[1]; ctx.fillRect(rect.x, y + 3, rect.w, 2);
          for (var x = rect.x - 32 + (row % 2) * 16; x < rect.x + rect.w; x += 32) { ctx.fillStyle = palette[2]; ctx.fillRect(x, y, 3, 22); ctx.fillStyle = palette[1]; ctx.fillRect(x + 3, y + 4, 2, 16); }
          row++;
        }
        ctx.restore(); ctx.strokeStyle = '#463b42'; ctx.lineWidth = 2; ctx.strokeRect(rect.x, rect.y, rect.w, rect.h);
      }
      function drawStar() {
        var p = state.player, vy = state.phase === 'ready' ? 0 : p.vy, bob = state.phase === 'ready' ? Math.sin(performance.now() / 320) * 6 : 0;
        ctx.save(); ctx.translate(p.x, p.y + bob); ctx.rotate(clamp(vy / 900, -0.3, 0.65));
        var squash = state.jumpAge < 0.14 ? Math.sin(state.jumpAge / 0.14 * Math.PI) * 0.1 : 0;
        ctx.scale(1 - squash, 1 + squash);
        var expression = state.phase === 'over' ? bumpSprite : state.phase === 'running' && p.vy > 100 ? fallSprite : sprite;
        if (!expression.complete || !expression.naturalWidth) expression = sprite;
        if (expression.complete && expression.naturalWidth) ctx.drawImage(expression, -29, -29, 58, 58);
        else {
          ctx.beginPath(); for (var n = 0; n < 10; n++) { var a = -Math.PI / 2 + n * Math.PI / 5, r = n % 2 ? 14 : 29; if (!n) ctx.moveTo(Math.cos(a)*r, Math.sin(a)*r); else ctx.lineTo(Math.cos(a)*r, Math.sin(a)*r); }
          ctx.closePath(); ctx.fillStyle = '#ffd334'; ctx.fill(); ctx.lineWidth = 3; ctx.strokeStyle = '#243b37'; ctx.stroke();
          ctx.fillStyle = '#243b37'; ctx.beginPath(); ctx.ellipse(3,-5,2,4,0,0,Math.PI*2); ctx.ellipse(13,-5,2,4,0,0,Math.PI*2); ctx.fill(); ctx.beginPath(); ctx.arc(8,0,9,0.1,Math.PI-0.1); ctx.stroke();
        }
        if (state.phase === 'over') { ctx.strokeStyle = '#fff1c9'; ctx.lineWidth = 2; for (var k = 0; k < 5; k++) { var angle = k * Math.PI * 2 / 5; ctx.beginPath(); ctx.moveTo(Math.cos(angle)*33,Math.sin(angle)*33); ctx.lineTo(Math.cos(angle)*38,Math.sin(angle)*38); ctx.stroke(); } }
        ctx.restore();
      }
      function render() {
        ctx.clearRect(0, 0, W, H);
        if (window.NorthstarWaterfront) window.NorthstarWaterfront.draw(ctx, { width: W, height: H, distance: state.distance, night: state.night, time: state.time });
        else { var sky = ctx.createLinearGradient(0,0,0,H); sky.addColorStop(0,'#82bcbb'); sky.addColorStop(0.6,'#f9dab0'); sky.addColorStop(1,'#25777c'); ctx.fillStyle = sky; ctx.fillRect(0,0,W,H); }
        state.obstacles.forEach(function (o) { rectangles(o).forEach(function (r) { brick(r, o.tone); }); });
        ctx.fillStyle = '#253f40'; ctx.fillRect(0,FLOOR,W,H-FLOOR); ctx.fillStyle = '#d3b38a'; ctx.fillRect(0,FLOOR,W,7);
        ctx.strokeStyle = '#56716a'; ctx.lineWidth = 2;
        for (var i = -50; i < W+50; i += 45) { var x = i - state.distance % 45; ctx.beginPath(); ctx.moveTo(x,FLOOR+18); ctx.lineTo(x+24,FLOOR+18); ctx.stroke(); }
        drawStar();
        if (paused) { ctx.fillStyle = 'rgba(23,35,42,.6)'; ctx.fillRect(0,0,W,H); ctx.fillStyle = '#fff4d9'; ctx.textAlign = 'center'; ctx.font = 'bold 24px sans-serif'; ctx.fillText(el.dataset.pausedText,W/2,H/2); }
        if (lastScore !== state.score) { score.textContent = String(state.score).padStart(2,'0'); lastScore = state.score; }
      }
      function tick(time) {
        if (destroyed) return;
        if (previous && !paused && !doc.hidden) accumulator += Math.min((time - previous) / 1000, 0.1);
        previous = time;
        while (accumulator >= FIXED && state.phase === 'running' && !paused) { model.step(FIXED); accumulator -= FIXED; if (state.phase === 'over') finish(); }
        if (state.phase !== 'running') accumulator = 0;
        render(); frame = requestAnimationFrame(tick);
      }
      function resize() { var ratio = Math.min(window.devicePixelRatio || 1, 2); canvas.width = W * ratio; canvas.height = H * ratio; ctx.setTransform(ratio, 0, 0, ratio, 0, 0); }
      window.addEventListener('resize', resize, eventOptions);
      doc.addEventListener('shopify:section:unload', function (event) {
        if (event.target.contains(el)) {
          destroyed = true; stopRedirect(); cancelAnimationFrame(frame); abort.abort(); delete el.dataset.nsMounted;
          title.textContent = readyCopy.title; message.textContent = readyCopy.message; start.textContent = readyCopy.start;
          overlay.hidden = false; hats.hidden = true; if (rewardArt) rewardArt.hidden = true; pauseButton.hidden = true; score.textContent = '00'; status.textContent = '';
        }
      }, eventOptions);
      resize(); frame = requestAnimationFrame(tick);
    }
    function mountInDocument() { doc.querySelectorAll('[data-ns-game]').forEach(mount); }
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', mountInDocument, { once: true }); else mountInDocument();
    doc.addEventListener('shopify:section:load', mountInDocument);
  }
  return { createGame: createGame, qualifies: qualifies, rewardUrl: rewardUrl, rectangles: rectangles, intersects: intersects, FIXED: FIXED, mountAll: mountAll };
});
